import { message } from 'antd';
import { useEffect, useState } from 'react';
import { getFormSignature } from '../../../services/exam';

const useSignatureData = (admissionPatientExamId) => {
  const [loading, setLoading] = useState(false);
  const [examData, setExamData] = useState();

  const handleMessage = (content, state) => {
    if (state === 'success') {
      message.success({
        content,
        style: {
          marginTop: '40vh',
        },
      });
    } else {
      message.error({
        content,
        style: {
          marginTop: '40vh',
        },
      });
    }
  };

  useEffect(() => {
    const fetchExamData = async () => {
      try {
        setLoading(true);
        const response = await getFormSignature({ admissionPatientExamId });
        setExamData(response);
      } catch (error) {
        console.error(`Error al traer datos del examen: ${error}`);
        handleMessage('error', `Error al traer datos del examen: ${error}`);
      } finally {
        setLoading(false);
      }
    };

    if (admissionPatientExamId) fetchExamData();
  }, [admissionPatientExamId]);

  return {
    loading,
    examData,
  };
};

export default useSignatureData;
